import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';

export default Backbone.Model.extend({
  url() {
    return this.get('url');
  },
  defaults: {
    non_redeemable: 0.0,
    redeemable: 0.0,
    promo_code: null,
  },
  initialize() {
    this.methodModels = {};
  },
  getTotalRoverBucks() {
    const result = _.values(this.methodModels).reduce(
      (memo, model) => memo + parseFloat(model.getTotalRoverBucks()),
      0
    );
    return result.toFixed(2);
  },
  clearRoverBucksMethods() {
    this.methodModels = {};
    this.triggerChange();
  },
  addRoverBucksMethod(methodModel) {
    this.methodModels[methodModel.url()] = methodModel;
    this.listenTo(methodModel, 'change', this.triggerChange);
    this.triggerChange();
  },
  getMethodModels() {
    return _.chain(this.methodModels)
      .values()
      .sortBy('sortOrder')
      .value();
  },
  triggerChange() {
    this.trigger('change');
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/RoverBucksModel.js